import { FC } from 'react';
import classNames from 'classnames';
import { getTextClassNames } from '@nx-frontend/shared/themes';
import { PortalStyleConfig, PortalTextType, ThemeColorSchemas } from '@nx-frontend/shared/types';
import { UiInputView } from './input';

export interface UiLabelProps {
  id: string;
  view: UiInputView;
  label?: string;
  labelSmallGrey?: boolean;
  disabled?: boolean;
  error?: boolean;
  isFocused?: boolean;
  themeColors?: ThemeColorSchemas;
  themeStyle?: PortalStyleConfig;
}

export const UiLabel: FC<UiLabelProps> = ({
  id,
  label,
  view,
  error,
  isFocused,
  labelSmallGrey,
  themeColors,
  themeStyle,
}) => {
  const textLabelFocus =
    themeColors && themeStyle
      ? classNames([...getTextClassNames(themeColors, PortalTextType.PRIMARY)])
      : 'text-cyan-900';
  const labelClass =
    view === UiInputView.LABEL_BORDER
      ? 'absolute text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] px-2 top-2 whitespace-nowrap text-ellipsis overflow-hidden -translate-y-4 left-2'
      : 'block mb-1 text-xs';

  if (!label) {
    return null;
  }
  return (
    <label
      htmlFor={id}
      title={label}
      className={classNames(labelClass, {
        [textLabelFocus]: isFocused,
        'bg-white': view === UiInputView.LABEL_BORDER,
        'peer-placeholder-shown:text-gray-400 peer-focus:text-cyan-900': !error,
        'text-red-600 peer-placeholder-shown:text-red-500 peer-focus:text-red-500': error,
        '!text-[10px] text-neutral-500 uppercase leading-[12px] tracking-[0.2px]': labelSmallGrey,
      })}
      style={view === UiInputView.LABEL_BORDER ? { maxWidth: 'calc(133.33% - 1.5rem)' } : {}}
    >
      {label}
    </label>
  );
};
